"use client";

import { TaskDescriptionSection } from "./TaskDescriptionSection";
import { TaskInformationSection } from "./TaskInformationSection";
import { TaskContactDisplay } from "./tabs/TaskContactDisplay";
import { TaskLinkedCompanyPanel } from "./tabs/TaskLinkedCompanyPanel";
import { TaskLinkedDealPanel } from "./tabs/TaskLinkedDealPanel";
import { TaskLinkedOfferingPanel } from "./tabs/TaskLinkedOfferingPanel";
import { TaskLinkedTicketPanel } from "./tabs/TaskLinkedTicketPanel";
import { TaskLinkedTimeEntryPanel } from "./tabs/TaskLinkedTimeEntryPanel";
import { TaskAISummaryTab } from "./task-detail-tabs/TaskAISummaryTab";
import { TaskAssigneesDisplay } from "./task-detail-tabs/TaskAssigneesDisplay";
import {
  ContactInfoTab,
  TaskActivityTimelineTab,
  TaskNotesTab,
} from "./task-detail-tabs/TaskBasicTabs";
import { TaskCompanyDisplay } from "./task-detail-tabs/TaskCompanyDisplay";

export { TaskAISummaryTab } from "./task-detail-tabs/TaskAISummaryTab";
export { TaskAssigneesDisplay } from "./task-detail-tabs/TaskAssigneesDisplay";
export {
  ContactInfoTab,
  TaskActivityTimelineTab,
  TaskNotesTab,
} from "./task-detail-tabs/TaskBasicTabs";
export { TaskCompanyDisplay } from "./task-detail-tabs/TaskCompanyDisplay";
export { TaskDescriptionSection } from "./TaskDescriptionSection";
export { TaskInformationSection } from "./TaskInformationSection";
export {
  TaskContactDisplay,
  TaskLinkedCompanyPanel,
  TaskLinkedDealPanel,
  TaskLinkedOfferingPanel,
  TaskLinkedTicketPanel,
  TaskLinkedTimeEntryPanel,
};

export const TaskDetailTabComponents = {
  TaskAISummary: TaskAISummaryTab,
  TaskDescriptionSection,
  TaskInformationSection,
  TaskNotesDisplay: TaskNotesTab,
  TaskActivityTimeline: TaskActivityTimelineTab,
  TaskCompanyDisplay,
  TaskAssigneesDisplay,
  TaskContactDisplay,
  TaskLinkedDealPanel,
  TaskLinkedTicketPanel,
  TaskLinkedCompanyPanel,
  TaskLinkedTimeEntryPanel,
  TaskLinkedOfferingPanel,
  ContactInfoDisplay: ContactInfoTab,
};
